export default "__VITE_ASSET__DjCuvzYs__"